function Service(data){
    let service = data || {};
    this.connectionType = service.connectionType;
    this.id = service.id;
    this.lifeEvent = service.lifeEvent;
}
module.exports = Service;